import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MailchimpFormModule } from "../mailchimp-form/mailchimp-form.module";
import { NavigationDirectiveModule } from "@sitemule/ng-components/directives/navigation";

import { FooterComponent } from "./footer.component";


@NgModule({
  declarations: [
    FooterComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MailchimpFormModule,
    NavigationDirectiveModule,
  ],
  exports:[FooterComponent],
  providers: [],
  bootstrap: [],
})
export class FooterModule {}
